<template>
  <div>
    <span @click="handleClick">
      <el-input
        v-model="goodsIds"
        @click="handleClick"
        placeholder="多个ID以逗号分隔"
        readonly
      ></el-input> </span
    ><!-- 选择商品组件 -->
    <select-goods
      v-if="goodsVisible"
      :isNeedSku="isNeedSku"
      :isSku="isSku"
      @transferName="goodsPopupBtn"
      @close="handleClose"
      :postForm="postForm"
    ></select-goods>
  </div>
</template>

<script>
import selectGoods from "@/components/select-goods.vue";
export default {
  name: "",
  components: {
    selectGoods,
  },
  model: {
    prop: "goodsIds",
    event: "update",
  },
  props: {
    goodsIds: {
      type: String,
    },
    isNeedSku: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      postForm: [], // 选择的商品列表
      goodsVisible: false,
      isSku: false,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClick() {
      this.goodsVisible = true;
    },
    goodsPopupBtn(event, index, isSku = false) {
      this.isSku = isSku;
      this.goodsVisible = false;
      if (this.isSku) {
        if (typeof event != "boolean") {
          let newArr = [];
          event.forEach((item) => {
            newArr.push(item.skuId);
          });
          if (index && index == 1) {
            this.postForm = event;
            this.$emit("update", newArr.join(","));
            this.$emit("changeSku", isSku);
          }
        }
      } else {
        if (typeof event != "boolean") {
          let newArr = [];
          event.forEach((item) => {
            newArr.push(item.numIid);
          });
          if (index && index == 1) {
            this.postForm = event;
            this.$emit("update", newArr.join(","));
            this.$emit("changeSku", false);
          }
        }
      }
    },
    handleClose() {
      console.log("close");
      this.goodsVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
